import { useFeatureFlags } from '@/lib/telemetry';

/**
 * PostHog flag behind every "Espaços" surface — the scope switcher entries, the
 * "Enviar para espaço" pill in the transaction row, the personal "Espaços e regras"
 * page and every /spaces/* route. Default-off through useFeatureFlags: with the flag
 * off the existing personal experience is preserved. Backend authentication and
 * membership checks remain authoritative; this flag is not authorization.
 *
 * Flag: https://us.posthog.com/project/475137/feature_flags/887825
 */
export const SPACES_FLAG = 'shared-spaces';

/** True only while PostHog resolves `shared-spaces` on for this person. */
export function useSpacesEnabled(): boolean {
  return useFeatureFlags(SPACES_FLAG);
}
